<!--
  ~ Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" *ngIf="showSpinner" id="export-load-spinner"></fab-loading-spinner>

<button *ngIf="buttonStyle === 'default'" mat-raised-button id="export-button" class="action-button"
        [disabled]="disabled"
        [color]="color"
        (click)="exportToExcel()">
  {{buttonText}}
</button>

<mat-icon *ngIf="buttonStyle === 'icon'" id="export-icon-button" class="export-icon-button" (click)="exportToExcel()"
          color="primary"
          (keydown)="exportToExcel()">
  get_app
</mat-icon>
